export default __webpack_public_path__ + "static/media/2026_banner_3.0831241c.png";